<template>
  <div class="relative">
    <!-- User Icon Button -->
    <button :class="[
              'relative p-2 text-foreground hover:text-primary transition-colors rounded-lg hover:bg-primary/10',
              authStore.headerIconColor,
            ]"
            aria-label="User account"
            title="User account"
            @click="toggleDropdown">
      <font-awesome-icon :icon="['fas', 'user-music']"
                         class="text-2xl" />
    </button>

    <!-- Floating User Dropdown Panel -->
    <UserDropdownPanel :is-open="isOpen"
                       @close="closeDropdown"
                       @login-clicked="handleLoginClick"
                       @logout-clicked="handleLogoutClick" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import UserDropdownPanel from '@/components/auth/UserDropdownPanel.vue';

const authStore = useAuthStore();
const isOpen = ref(false);

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const closeDropdown = () => {
  isOpen.value = false;
};

const handleLoginClick = () => {
  // This will be handled by parent component or UserDropdownPanel
  closeDropdown();
};

const handleLogoutClick = () => {
  // This will be handled by parent component or UserDropdownPanel
  closeDropdown();
};
</script>
